import axiosInstance from "../../../axios/Axios";

export function requestAddItem(action) {
  return () => {
    const formData = action.payload;
    axiosInstance.post(`products/item/create/`, {
      name: formData.name,
      number: formData.number,
      status: formData.status,
      description: formData.description,
    });
  };
}

export function requestGetAllItems() {
  return axiosInstance.request({
    method: "get",
    url: "products/",
  });
}

export function requestEditItem(action) {
  return () => {
    const formData = action.payload;
    axiosInstance.patch(`/products/item/` + formData.slug, {
      name: formData.name,
      number: formData.number,
      status: formData.status,
      description: formData.description,
    });
  };
}

export function requestDeleteItem(action) {
  return () => {
    const data = action.payload;
    console.log(data);
    axiosInstance.delete(`products/item/` + data, {});
  };
}
